import Vue from 'vue'
import Router from 'vue-router'


// 路由页面导入
import login from '../components/login.vue' //登录页面
import main from '../components/main.vue' //主页面
import notFound from '../components/404.vue' //404页面



// 公共模块
var menu = res => require(['@/components/comps/menu.vue'], res) //公共侧边栏和顶部菜单
// 数据监控
var realTimeMonitoring = res => require(['@/components/monitoring/realTimeMonitoring.vue'], res) //实时监控
var MonthlyDataAnalysis = res => require(['@/components/monitoring/MonthlyDataAnalysis.vue'], res) //月数据分析
var ViolationsData = res => require(['@/components/monitoring/ViolationsData.vue'], res) //违规数据分析
var bikeList = res => require(['@/components/monitoring/bikeList.vue'], res) //车辆列表
var bikeLog = res => require(['@/components/monitoring/bikeLog.vue'], res) //车辆日志
var operatorList = res => require(['@/components/monitoring/operatorList.vue'], res) //运营商列表
var opertorDetails = res => require(['@/components/monitoring/opertorDetails.vue'], res) //运营商列表详情
var subAccountManagement = res => require(['@/components/monitoring/subAccountManagement.vue'], res) //运营商子账号管理
var serviceConfigMap = res => require(['@/components/monitoring/serviceConfigMap.vue'], res) //服务区管理
var parkDetail = res => require(['@/components/monitoring/parkDetail.vue'], res) //P点详情编辑
var parkDetails = res => require(['@/components/monitoring/parkDetails.vue'], res) //P点详情编辑2

var parkManagement = res => require(['@/components/monitoring/parkManagement.vue'], res) //P点管理
var carMapModel = res => require(['@/components/mmassets/carMapModel.vue'], res) //车辆管理地图模式
var bikeTrajectory = res => require(['@/components/mmassets/bikeTrajectory.vue'], res) //车辆轨迹

// 违停管理
var violat = res => require(['@/components/violatNode/violat.vue'], res) //违规记录
var violatDetail = res => require(['@/components/violatNode/violatDetail.vue'], res) //违规记录详情
var dataExcepion = res => require(['@/components/violatNode/dataExcepion.vue'], res) //数据异样管理

// 系统设置
var authority = res => require(['@/components/setup/authority.vue'], res) //角色权限
var account = res => require(['@/components/setup/account.vue'], res) //平台账号
var menuManagement = res => require(['@/components/setup/menuManagement.vue'], res) //菜单权限管理
// 运营管理
var dataScreen = res => require(['@/components/managcent/dataScreen.vue'], res) //数据大屏
var heatMap = res => require(['@/components/managcent/heatMap.vue'], res) //P点热力统计
// 资产管理

var carsMana = res => require(['@/components/mmassets/carsManage.vue'], res) //车辆管理
var carDetails = res => require(['@/components/mmassets/cardetails.vue'], res) //车辆管理
var controlDetails = res => require(['@/components/mmassets/controlDetails.vue'], res) //中控详情
var motorbikeDetail = res => require(['@/components/mmassets/motorbikeDetail.vue'], res) //摩托车详情


const router = new Router({
  linkActiveClass: 'active',
  Router,
  // })

  // 懒加载方式，当路由被访问的时候才加载对应组件
  // Vue.use(Router)
  // export default new Router({
  routes: [{
    path: '/',
    redirect: {
      name: '登录'
    }
  }, {
    path: '/login',
    name: '登录',
    component: login
  },
  {
    path: '/menu',
    // name: '菜单栏',
    component: menu,
    children: [{
      path: '/',
      component: main
    },
    {
      path: '/notFound',
      name: '404',
      component: notFound
    }, {
      path: '/main',
      name: '工作台',
      component: main
    },
    {
      path: '/realTimeMonitoring',
      name: '实时监控',
      component: realTimeMonitoring
    }, {
      path: '/MonthlyDataAnalysis',
      name: '月数据分析',
      component: MonthlyDataAnalysis
    }, {
      path: '/ViolationsData',
      name: '违规数据分析',
      component: ViolationsData
    },
    {
      path: '/bikeList',
      name: '车辆列表',
      component: bikeList
    }, {
      path: '/bikeLog',
      name: '车辆日志',
      component: bikeLog
    }, {
      path: '/operatorList',
      name: '运营商管理',
      component: operatorList
    }, {
      path: '/opertorDetails',
      name: '运营商管理详情',
      component: opertorDetails
    }, {
      path: '/subAccountManagement',
      name: '运营商子账号管理',
      component: subAccountManagement
    }, {
      path: '/serviceConfigMap',
      name: '服务区管理',
      component: serviceConfigMap
    }, {
      path: '/parkDetail',
      name: 'P点详情编辑',
      component: parkDetail
    }, {
      path: '/parkDetails',
      name: 'P点详情编辑2',
      component: parkDetails
    }, {
      path: '/parkManagement',
      name: 'P点管理',
      component: parkManagement
    },
    // 违停管理
    {
      path: '/violat',
      name: '违停管理',
      component: violat
    },
    {
      path: '/violatDetail',
      name: '违停管理',
      component: violatDetail
    },
    {
      path: '/dataExcepion',
      name: '异常数据管理',
      component: dataExcepion
    },
    // 运营管理
    {
      path: '/dataScreen',
      name: '数据大屏',
      component: dataScreen,
    },
    {
      path: '/heatMap',
      name: 'P点统计',
      component: heatMap
    },
    // 资产管理
    {
      path: '/carsMana',
      name: '车辆管理',
      component: carsMana
    }, {
      path: '/carDetails',
      name: '车辆详情',
      component: carDetails,
    }, {
      path: '/motorbikeDetail',
      name: '摩托车详情',
      component: motorbikeDetail,
    }, {
      path: '/carMapModel',
      name: '车辆管理地图模式',
      component: carMapModel,
    }, {
      path: '/controlDetails',
      name: '中控详情',
      component: controlDetails
    }, {
      path: '/bikeTrajectory',
      name: '车辆轨迹',
      component: bikeTrajectory
    },
    // 设置
    {
      path: '/menuManagement',
      name: '菜单权限管理',
      component: menuManagement
    }, {
      path: '/authority',
      name: '权限设置',
      component: authority
    }, {
      path: '/account',
      name: '平台账号',
      component: account
    }
    ]
  }]
})


Vue.use(Router)
router.beforeEach((to, from, next) => {

  const nextRoute = ['main', 'searchbike', 'carsMana', 'controlMana'];
  let isLogin = sessionStorage.getItem("token")

  if (nextRoute.indexOf(to.path) >= 0) {
    if (!isLogin) {
      router.push({ path: "/login" })
    }
  }
  if (to.path === '/login') {
    if (isLogin) {
      router.push({ path: '/main' });
    }
  };
  next();
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js